import { all, call, put, takeLatest } from "redux-saga/effects";
import { FetchDataPointList } from "./services";
import * as dataPointActions from "./action";

export function* fetchDataPointListSaga(action) {
  try {
    const response = yield call(FetchDataPointList, action.payload);
    let dataPoint;
    dataPoint = response?.data?.data ? response?.data?.data : [];
    dataPoint.list = dataPoint.result;
    delete dataPoint.result;
    yield put(dataPointActions.FetchDataPointListSuccess(dataPoint));
  } catch (error) {
    yield put(dataPointActions.FetchDataPointListFailed(error));
  }
}
export function* fetchDataPointListMoreSaga(action) {
  try {
    const response = yield call(FetchDataPointList, action.payload);
    let dataPoint;
    dataPoint = response?.data?.data ? response?.data?.data : [];
    dataPoint.list = dataPoint.result;
    delete dataPoint.result;
    yield put(dataPointActions.LoadMoreDataPointSuccess(dataPoint));
  } catch (error) {
    yield put(dataPointActions.LoadMoreDataFailed(error));
  }
}
export function* dataPointWatcher() {
  yield all([
    takeLatest(dataPointActions.types.DATA_POINT_LIST, fetchDataPointListSaga),
  ]);
  yield all([
    takeLatest(
      dataPointActions.types.LOAD_MORE_DATAPOINT,
      fetchDataPointListMoreSaga,
    ),
  ]);
}
